import { createSlice } from "@reduxjs/toolkit";
import { infoCasa } from "../../designs/calendario-reserva/typeCasa";

interface initial_state {
    house: infoCasa;
    checking: boolean;
}

const INITIAL_STATE: initial_state = {
    house: {
        banner: "",
        casa_actividades: [],
        casa_comodidades: [],
        casa_habitaciones: [],
        casa_imagenes: [],
        casa_estadias_minimas: [],
        ciudad: "",
        departamento: "",
        fecha_registro: "",
        habilitado: "",
        id: 0,
        id_propietario: 0,
        latitud: "",
        longitud: "",
        nombre: "",
        pagina: "bienvenida",
        disponibilidades: {
            arrayDias: [],
            arrayFechas: [],
        },
        pedidos: {
            arrayFechasPedido: [],
        },
        descuentos_tiempos: [],
        personas_adicionales: [],
        precios_variables: [],
        servicios_adicionales: [],
        hotel_habitaciones: [],
        hotel_tours: [],
        resenas: [],
        pais: "",
        precio_base: "0",
        tema: "",
        terminado: "",
        tipo_moneda: "",
        whatsapp: "",
        personas: 0,
        banos: "0",
        habitaciones: "0",
        mascotas: 0,
        checking: true,
        estadia_maxima: 2,
        estadia_minima: 3,
        clave: "",
        check_in: "",
        check_out: "",
        garantia: "0",
        is_mercado_pago: "No",
        mensaje_bienvenida: "",
        tipo_garantia: "",
        plan: 0,
        unidades: 0,
        precios_variables_semanas: [],
        descripcion_1: "",
        descripcion_2: "",
        titulo_descripcion_1: "",
        titulo_descripcion_2: "",
        tipo_descripcion: "",
        imagen_descripcion: "",
        video_descripcion: "",
        tiempo_respuesta: "",
        dominio: "",
        dias_restantes: 0,
        prueba: "No",
        direccion: "",
        tiktok: "",
        facebook: "",
        instagram: "",
        id_airbnb: "",
        id_booking: "",
        id_tripadvisor: "",
        token_google_calendar: "",
        isChatbot: "",
        tipo_usuario: 0,
        tipo_inmueble: null,
        tipo_calendario: null,
        token_whatsapp: "",
        pago_prereserva: "No",
        dos_pagos: "No",
        porcentaje_primer_pago: "0",
        is_facturacion: false,
        is_niubiz: false,
    },
    checking: true,
};

const INITIAL_STATE_RESET: initial_state = {
    house: {
        banner: "",
        casa_actividades: [],
        casa_comodidades: [],
        casa_habitaciones: [],
        casa_imagenes: [],
        casa_estadias_minimas: [],
        ciudad: "",
        departamento: "",
        fecha_registro: "",
        habilitado: "",
        id: 0,
        id_propietario: 0,
        latitud: "",
        longitud: "",
        nombre: "",
        pagina: "bienvenida",
        disponibilidades: {
            arrayDias: [],
            arrayFechas: [],
        },
        pedidos: {
            arrayFechasPedido: [],
        },
        descuentos_tiempos: [],
        personas_adicionales: [],
        precios_variables: [],
        servicios_adicionales: [],
        hotel_habitaciones: [],
        hotel_tours: [],
        resenas: [],
        pais: "",
        precio_base: "0",
        tema: "",
        terminado: "",
        tipo_moneda: "",
        whatsapp: "",
        personas: 0,
        banos: "0",
        habitaciones: "0",
        mascotas: 0,
        checking: true,
        estadia_maxima: 2,
        estadia_minima: 3,
        clave: "",
        check_in: "",
        check_out: "",
        garantia: "0",
        is_mercado_pago: "No",
        mensaje_bienvenida: "",
        tipo_garantia: "",
        plan: 0,
        unidades: 0,
        precios_variables_semanas: [],
        descripcion_1: "",
        descripcion_2: "",
        titulo_descripcion_1: "",
        titulo_descripcion_2: "",
        tipo_descripcion: "",
        imagen_descripcion: "",
        video_descripcion: "",
        tiempo_respuesta: "",
        dominio: "",
        dias_restantes: 0,
        prueba: "No",
        direccion: "",
        tiktok: "",
        facebook: "",
        instagram: "",
        id_airbnb: "",
        id_booking: "",
        id_tripadvisor: "",
        token_google_calendar: "",
        isChatbot: "",
        tipo_usuario: 0,
        tipo_inmueble: null,
        tipo_calendario: null,
        token_whatsapp: "",
        pago_prereserva: "No",
        dos_pagos: "No",
        porcentaje_primer_pago: "0",
        is_facturacion: false,
        is_niubiz: false,
    },
    checking: false,
};

export const landing_house = createSlice({
    name: "landing_house",
    initialState: INITIAL_STATE,
    reducers: {
        set_landing_house: (state, action) => {
            console.log(action.payload);
            return {
                house: action.payload,
                checking: false,
            };
        },

        reset_landing_house: () => INITIAL_STATE_RESET,
    },
});

// Action creators are generated for each case reducer function
export const { set_landing_house, reset_landing_house } = landing_house.actions;

export default landing_house.reducer;
